import { LockKey, Crown } from "@phosphor-icons/react";
import { goUpgrade } from "@/lib/planAccess";

export default function UpgradeGate({ title = "Upgrade to unlock", description = "This feature is available on Pro and Premium plans.", children, compact = false }) {
  return (
    <div className={`relative overflow-hidden rounded-2xl border border-blue-500/20 bg-[#0B0B0D] ${compact ? "p-4" : "p-7 sm:p-10"}`} data-testid="upgrade-gate">
      <div className="absolute inset-0 bg-blue-500/[0.03] pointer-events-none" />
      <div className="relative text-center max-w-xl mx-auto">
        <div className="mx-auto w-11 h-11 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-4">
          <LockKey size={20} className="text-blue-400" />
        </div>
        <h2 className="text-lg sm:text-xl font-medium text-white">{title}</h2>
        <p className="text-sm text-zinc-500 mt-2 leading-relaxed">{description}</p>
        {children}
        <button onClick={goUpgrade} className="mt-5 inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg text-sm font-medium">
          <Crown size={16} weight="fill" /> Upgrade plan
        </button>
      </div>
    </div>
  );
}
